import { Controller } from "@hotwired/stimulus"

// Notifies the parent SCORM launcher frame when a training completes.
// Attach to the completion page with data-controller="scorm-notifier"
// and set data-scorm-notifier-complete-url-value to the PASS SCORM complete endpoint.
export default class extends Controller {
  static values = { completeUrl: String }

  connect() {
    if (window.parent === window) return // not in an iframe

    window.parent.postMessage({
      type: "scorm-completion",
      status: "completed",
      score: 100
    }, "*")

    // Log completion to PASS so ScormSessionLog records it
    if (this.hasCompleteUrlValue) {
      const csrfToken = document.querySelector("meta[name='csrf-token']")?.content
      fetch(this.completeUrlValue, {
        method: "POST",
        headers: {
          "X-CSRF-Token": csrfToken,
          "Content-Type": "application/json"
        }
      }).catch(() => {}) // best-effort logging
    }
  }
}
